var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import GrimoireInterface from "../Interface/GrimoireInterface";
import GomlParser from "./GomlParser";
import XMLReader from "../Base/XMLReader";
import XMLHttpRequestAsync from "../Base/XMLHttpRequestAsync";
/**
 * Provides the features to fetch Goml source.
 */
class GomlLoader {
    /**
     * Obtain the Goml source from specified tag.
     * @param  {HTMLScriptElement} scriptTag [the script tag to load]
     * @return {Promise<void>}               [the promise to wait for loading]
     */
    static loadFromScriptTag(scriptTag) {
        return __awaiter(this, void 0, void 0, function* () {
            const srcAttr = scriptTag.getAttribute("src");
            let source;
            if (srcAttr) {
                // ignore text element
                const req = new XMLHttpRequest();
                req.open("GET", srcAttr);
                yield XMLHttpRequestAsync.send(req);
                source = req.responseText;
            }
            else {
                source = scriptTag.text;
            }
            const doc = XMLReader.parseXML(source, "GOML");
            const rootNode = GomlParser.parse(doc[0]);
            GrimoireInterface.addRootNode(scriptTag, rootNode);
        });
    }
    /**
     * Load from the script tags which will be found with specified query.
     * @param  {string}          query [the query to find script tag]
     * @return {Promise<void[]>}       [the promise to wait for all goml loading]
     */
    static loadFromQuery(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const tags = document.querySelectorAll(query);
            const pArray = [];
            const elements = [];
            for (let i = 0; i < tags.length; i++) {
                const element = tags.item(i);
                elements.push(element);
                pArray[i] = GomlLoader.loadFromScriptTag(element);
            }
            if (pArray.length === 0 && GrimoireInterface.debug) {
                console.warn("There was no goml file detected. Have you specified `type='text/goml'` to the script tag?");
            }
            yield Promise.all(pArray);
            GomlLoader.initializedEventHandlers.forEach(handler => {
                handler();
            });
            this.callInitializedAlready = true;
        });
    }
    /**
     * Load all Goml sources contained in HTML.
     * @return {Promise<void>} [the promise to wait for all goml loading]
     */
    static loadForPage() {
        return __awaiter(this, void 0, void 0, function* () {
            yield GomlLoader.loadFromQuery('script[type="text/goml"]');
        });
    }
}
GomlLoader.callInitializedAlready = false;
GomlLoader.initializedEventHandlers = [];
export default GomlLoader;



// WEBPACK FOOTER //
// ./src/Node/GomlLoader.ts